// extracted by mini-css-extract-plugin
module.exports = {"viewImagePageContainer":"ImageView_viewImagePageContainer__25MPf"};